const DESIGNATIONS_TABLE_READY = "designations-table-ready"
const SEARCH_TEXT_STATE = "designations-table-search-text-state"
const ROWS_PER_PAGE_STATE = "designations-table-rows-per-page-state"
const PAGINATION_STATE = "designations-table-pagination-state"

const DESIGNATIONS_ID_FOR_ACTION = "designations-table-brand-id-for-action"


const ADDEDIT_DESIGNATIONS_READY = "designations-table-addedit-designations-ready"

const initialState = {
    isDesignationsTableReady: true,
    isAddEditDesignationsReady: true,
    designations: {},

    
    designationsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case DESIGNATIONS_TABLE_READY:
            return Object.assign({}, state, { isDesignationsTableReady: action.payload })

        case ADDEDIT_DESIGNATIONS_READY:
            return Object.assign({}, state, { isAddEditDesignationsReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case DESIGNATIONS_ID_FOR_ACTION:
            return Object.assign({}, state, {designationsSelectedId:action.payload})

        default:
        return state
    
    }

}

export function designationsTableReady(data) {
    return {
        type: DESIGNATIONS_TABLE_READY,
        payload: data
    }
}

export function addEditDesignationsReady(data) {
    return {
        type: ADDEDIT_DESIGNATIONS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function designationsIdForAction(designationsId){
    return{
        type:DESIGNATIONS_ID_FOR_ACTION,
        payload:designationsId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Designations/redux/designations.js